import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { PackageFareDetails } from "redmond";
import { IStoreState } from "../../reducers/types";

import { PackageItineraryReview } from "./component";
import {
  getSelectedReturnFlightPackage,
  selectedFareDetailsSelector,
} from "../flight-shop/reducer";
import { finalizePackage } from "./actions/actions";
import {
  getSelectedPackageByLodgingId,
  selectedPackageByRateId,
} from "../hotel-shop/reducer";
import { getDepartureDate, getReturnDate } from "../search/reducer";
import {
  getPackageAvailabilityAdultsCount,
  getPackageAvailabilityChildren,
  getPackageAvailabilityInfants,
  getPackageNightCountBasedOnAvailability,
  getTravelersCount,
} from "../availability/reducer";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../rewards/reducer";
import { getFinalizePackageCallState } from "./reducer/selectors";
import {
  getPackagedAirComponent,
  getPackagedRoomComponent,
  getPackagePollState,
  getPackageSearchKey,
} from "../package-identity/reducer/selectors";
import { getPackagePricingIdentity } from "../hotel-shop/utils/usePackagePricingIdentity";

const mapStateToProps = (state: IStoreState) => ({
  selectedPackageByLodging: getSelectedPackageByLodgingId(state),
  rewardsKey:
    getSelectedAccountReferenceIdIfRedemptionEnabled(state) || undefined,
  nightCount: getPackageNightCountBasedOnAvailability(state),
  travelersCount: getTravelersCount(state),
  departureDate: getDepartureDate(state),
  returnDate: getReturnDate(state),
  finalizePackageCallState: getFinalizePackageCallState(state),
  selectedFareDetails: selectedFareDetailsSelector(state) as
    | PackageFareDetails
    | undefined,
  opaqueQuoteRequest: selectedPackageByRateId(state)?.opaqueQuoteRequest,
  opaquePackageToken: getSelectedReturnFlightPackage(state)?.opaquePackageToken,
  searchAdultsCount: getPackageAvailabilityAdultsCount(state),
  searchChildren: getPackageAvailabilityChildren(state),
  searchedInfants: getPackageAvailabilityInfants(state),
  // v2-sourced: read from the GetPackage snapshot instead of the handoff. The
  // raw components are kept (not just the resolved pricing) so the component can
  // still gate its "missing selection"/loading-skeleton logic on their presence.
  packagedAirComponentV2: getPackagedAirComponent(state),
  packagedRoomComponentV2: getPackagedRoomComponent(state),
  packagePollState: getPackagePollState(state),
  searchKey: getPackageSearchKey(state),
  packagePricing: getPackagePricingIdentity(state, {
    useLodgingFallback: true,
  }),
});

export const mapDispatchToProps = {
  finalizePackage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PackageItineraryReviewConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPackageItineraryReview = withRouter(
  connector(PackageItineraryReview),
);
